import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: 'Aptiv - Assembly Line with Traceability System',
      industry: 'Automotive',
      description: 'Complete assembly line automation project for clean room environment including assembly, packing, and testing operations. Full project execution with mechanical and controls design, integrated traceability system, and comprehensive data collection.',
      technologies: ['Rockwell Automation', 'Cognex Vision Systems', '.NET Traceability System', 'Mechanical Design', 'Controls Design', 'Data Collection'],
      results: [
        'Complete clean room assembly line automation',
        'Full traceability system integration',
        'End-to-end project execution from design to commissioning',
        'Comprehensive data collection and reporting'
      ]
    },
    {
      title: 'Cordis - Medical Device Assembly and Test',
      industry: 'Medical Devices',
      description: 'Single station medical device assembly and test system with integrated vision inspection. Designed for precision assembly and quality validation in medical device manufacturing.',
      technologies: ['Rockwell Automation', 'Cognex Vision Systems'],
      results: [
        'Precision medical device assembly',
        'Automated quality testing and validation',
        'Single station solution for efficient production'
      ]
    },
    {
      title: 'BBS Automation / Rivian - Plant Commissioning',
      industry: 'Automotive',
      description: 'Commissioning services for automation system at Rivian manufacturing plant. Complete PLC programming, motion control integration, and system commissioning for production line.',
      technologies: ['Beckhoff Automation', 'PLC Programming', 'Motion Control', 'Commissioning'],
      results: [
        'Successful system commissioning at Rivian plant',
        'PLC and motion control integration',
        'Production-ready automation system'
      ]
    },
    {
      title: 'International Packing Line Installation',
      industry: 'Consumer Products',
      description: 'Complete installation of entire high-speed packing line system for an OEM International Packing Company across multiple international locations. Full project execution including installation, startup, and ongoing support services.',
      technologies: ['Rockwell Automation', 'PackML', 'Delta Robots', 'High-Speed Packing', 'Installation', 'Startup', 'Support'],
      results: [
        'Multi-country installation: Mexico, Brazil, Argentina, Chile',
        'High-speed packing line automation with Delta Robots',
        'PackML implementation for standardized operation',
        'Complete installation and startup services',
        'Ongoing support across international locations'
      ]
    }
  ];

  return (
    <div className="projects-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Projects</h1>
          <p className="page-hero-subtitle">
            Successful automation implementations across diverse industries
          </p>
        </div>
      </section>

      <section className="projects-content">
        <div className="container">
          <div className="projects-intro">
            <p>
              Our portfolio showcases successful automation projects that have 
              delivered measurable results for our clients. Each project is 
              tailored to specific requirements and industry standards, 
              demonstrating our capability to deliver solutions that drive 
              real business value.
            </p>
          </div>

          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-card">
                <div className="project-header">
                  <span className="project-industry">{project.industry}</span>
                  <h2>{project.title}</h2>
                </div>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  <h3>Technologies Used:</h3>
                  <div className="tech-tags">
                    {project.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
                <div className="project-results">
                  <h3>Key Results:</h3>
                  <ul>
                    {project.results.map((result, idx) => (
                      <li key={idx}>{result}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className="projects-cta">
            <h2>Ready to Start Your Project?</h2>
            <p>Let's discuss how we can help automate your manufacturing processes</p>
            <a href="/contact" className="btn btn-primary">Get in Touch</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;

